import {
  PaginationHandler,
  PaginationInfo,
  usePaginatedQuery,
} from '@occc-app/hooks/usePaginatedQuery';
import { useGetScanDataMissingStoresDetailsQuery } from '@occc/graphql';

type UseScanDataMissingStoresDetailsParams = {
  search?: string;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
};

export const useScanDataMissingStoresDetails = ({
  search,
  paginationInfo,
  onPageChange,
}: UseScanDataMissingStoresDetailsParams = {}) => {
  return usePaginatedQuery(
    useGetScanDataMissingStoresDetailsQuery,
    'scanDataMissingStoresDetails.pageInfo',
    undefined,
    {
      variables: {
        filter: search ? { search } : undefined,
      },
    },
    paginationInfo,
    onPageChange,
  );
};
